import { useEffect } from 'react';
import { skipToken, useQuery } from '@apollo/client/react';

import { IGroupsQueryVariables, GroupsDocument } from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

export const useGroupList = (
    groupQueryVariables?: IGroupsQueryVariables,
    withSkills = false
) => {
    const { showApolloError } = useApolloError();

    const { data, loading, error } = useQuery(
        GroupsDocument,
        groupQueryVariables
            ? {
                  variables: { ...groupQueryVariables, withSkills },
                  notifyOnNetworkStatusChange: true,
              }
            : skipToken
    );

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    const groupsObject = data?.paginatedGroups;
    const groupsCount = groupsObject?.count;
    const groups =
        groupsObject?.edges.map((edge) => edge?.node || null).filter(Boolean) ||
        [];

    return {
        groups,
        groupsCount,
        loading,
    };
};
